"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButterflyEffect = void 0;
var Card_1 = require("../Card");
var CardName_1 = require("../../CardName");
var ShiftAresGlobalParametersDeferred_1 = require("../../deferredActions/ShiftAresGlobalParametersDeferred");
var CardType_1 = require("../CardType");
var CardRenderer_1 = require("../render/CardRenderer");
var Size_1 = require("../render/Size");
var ButterflyEffect = (function (_super) {
    __extends(ButterflyEffect, _super);
    function ButterflyEffect() {
        return _super.call(this, {
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.BUTTERFLY_EFFECT,
            cost: 8,
            metadata: {
                cardNumber: 'A03',
                description: 'Gain 1 TR. Move each individual hazard marker up to 1 step up or down.',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.tr(1).br;
                    b.plate('All hazard markers').colon().text('-1 / 0 / +1', Size_1.Size.SMALL);
                }),
            },
        }) || this;
    }
    ButterflyEffect.prototype.play = function (player) {
        player.increaseTerraformRating();
        player.game.defer(new ShiftAresGlobalParametersDeferred_1.ShiftAresGlobalParametersDeferred(player));
        return undefined;
    };
    return ButterflyEffect;
}(Card_1.Card));
exports.ButterflyEffect = ButterflyEffect;
